import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';

const Article = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: ${props => (props.theme.isPortrait ? '104px 20px 0 20px' : '116px 0 0 0')};
`;

const Header = styled.header`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 20px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 30px;
  text-transform: uppercase;
`;

const Paragraph = styled.p`
  margin: 0;
  margin-top: 15px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 15px;
  line-height: ${props => (props.theme.isPortrait ? 20 : 30)}px;
  text-align: center;
`;

// We want no more line wrapping after the 7th tile. Max-width does the trick.
const Logos = styled.div`
  margin-top: ${props => (props.theme.isPortrait ? 40 : 54)}px;
  max-width: 1276px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`;

// 40vw on mobile to make sure there is enough room for two logos per row
// 180px is the actual image width with blurred shadows around for desktop.
// Margin-top to compensate white space between lines because the image
// contains white space. This is portionally to the image's aspect ratio.
const Logo = styled(Img)`
  width: ${props => (props.theme.isPortrait ? '40vw' : '180px')};
  height: ${props => (props.theme.isPortrait ? '27.888889vw' : '125.5px')};
  margin-top: ${props => (props.theme.isPortrait ? '-6vw' : '-27px')};
  margin-left: -10px;
  margin-right: -10px;
`;

export default function Companies({ ebookName }) {
  const { partners } = React.useContext(ThemeContext);
  const desc = `Within “${ebookName}”, you’ll learn from the best managers and analysts.`;

  return (
    <Article>
      <Header>You’re in good company</Header>
      <Paragraph>{desc}</Paragraph>
      <Logos>
        {partners.map(partner => <Logo key={partner} src={partner} />)}
      </Logos>
    </Article>
  );
}

Companies.propTypes = {
  ebookName: PropTypes.string.isRequired,
};
